import Logo from "../components/Logo"
import Card from "../components/Card"
import Button from "../components/Button"
import { useParams, useNavigate } from "react-router-dom"


function ConfirmEmail() {
  const { id , token} = useParams();
  const navigate = useNavigate();


   const confirmEmail = async (id, token) => {
    const signUpOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json'},
  };
    await fetch(`${process.env.REACT_APP_API_URL}/auth/confirm-registration/${id}/${token}`, signUpOptions)
       .then( response => response.json())
        .then(data => {
          console.log('confirm email');
        })
        .catch(err => {
          console.log(err)
        })
  } 

  const handleConfirmRegistration = (e) => {
    confirmEmail(id, token);
    setTimeout(() => {
      navigate("/login")
    }, 3000)
    navigate("/redirecting")
 }


  return (
    <div className="signup-container">
    <Logo/>
    <Card>
    <div className="banner confirm-banner"></div>
    <h4 className="card-head"> 
    Verify Email
    </h4>
    <p className="card-text">
    Kindly click on the button below to verify your mail
    </p>
    <div className="confirm-btn" onClick={handleConfirmRegistration}>
    <Button type='submit'>
        Confirm Email
    </Button>
    </div>
   
    </Card>
    
</div>
  )
}

export default ConfirmEmail
